module.exports = __webpack_public_path__ + "static/media/HistoricUser.abe7bdcf.svg";